import * as Sentry from "@sentry/browser";

Sentry.init({
    dsn: "https://eb774b4ceb90051f46c20a7031c89121@o446808.ingest.sentry.io/4505947558576128",
    allowUrls: [/https?:\/\/(myfunrun|myevent)\.com/],
    integrations: [new Sentry.BrowserTracing(), new Sentry.Replay({'maskAllText': false, 'blockAllMedia': false})],

    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: 0.2,

    // Set `tracePropagationTargets` to control for which URLs distributed tracing should be enabled
    tracePropagationTargets: ["localhost", /^https:\/\/myfunrun.\.com/],

    // Capture Replay for 10% of all sessions,
    // plus for 100% of sessions with an error
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,

    ignoreErrors: [
        'Can\'t find variable: IFrameMessageHandler',
        'Could not load "util".',
        'Could not load "marker".',
        'Could not load "map".',
        'Could not load "controls".',
        'Can\'t find variable: HTMLDialogElement',
        'Timeout',
        'grecaptcha is not defined',
        'Could not load "onion".',
        'Can\'t find variable: google',
        'updateLocationData is not defined',
        'Cannot read properties of undefined (reading \'publishMetrics\')',
        'Could not load "geocoder".',
        'Non-Error promise rejection captured with value: Timeout',
        'Can\'t find variable: $'
    ]
});
